//
import Model from './Model'

//
export default class ExtendModel extends Model {
    //
    static appends = []
    static errors = {}
    static filters = []
    static forms = {}
    static headers = []
    static includes = []

    /**
     *
     */
    clean(props) {
        //
        var clone = this.clone()

        //
        Object.keys(clone).forEach(key => {
            if (!props.some(prop => prop === key)) {
                delete clone[key]
            }
        })

        //
        return clone
    }

    /**
     *
     */
    clone() {
        return Object.assign(Object.create(Object.getPrototypeOf(this)), this)
    }

    /**
     *
     */
    static async fetchDataTable(limit, page, sort, params = {}) {
        //
        try {
            //
            return await this.modeler()
                .limit(limit)
                .page(page)
                .orderBy(sort)
                .params(params)
                .get()
        } catch (error) {
            //
            //console.error( error )

            //
            return []
        }
    }

    /**
     * get the full url for the current model
     */
    fullURL() {
        return [this.baseURL(), this.resource(), this.id].join('/')
    }

    /**
     *
     */
    static modeler() {
        return this.append(this.appends).include(this.includes)
    }

    /**
     *
     */
    pdf() {
        return this.request({
            responseType: 'blob',
            method: 'GET',
            url: this.fullURL().concat('/pdf'),
        })
    }

    /**
     *
     */
    remove(data) {
        console.log({ data })
        return this.request({
            method: 'delete',
            url: this.fullURL(),
            data,
        })
    }

    /**
     *
     */
    replace(data) {
        return this.$http.request({
            method: 'patch',
            url: this._fromResource,
            data,
        })
    }

    /**
     *
     */
    reset() {
        return this
    }
}
